const getters = {
  // username: state => state.app.name
  // token: state => state.user.token
}// 这里申明可以直接获取的state
export default getters
